import { MetricsV1AggregationType } from '@spotify/confidence-graphql';

import { aggregationUtils } from '../../Aggregation';
import { AverageMeasurement, AverageMetricSpec } from './measurementInput';
import {
  applyCap,
  applyThreshold,
  coalesceToZeroIf,
  filterToWhereClause,
  quoteIdentifier,
} from './sqlHelpers';

export type AverageSnippetArgs = {
  entity?: string | null;
  factTable?: string | null;
  measurement: AverageMeasurement;
};

const buildAverageAggregation = (spec: AverageMetricSpec): string => {
  const aggLabel = aggregationUtils.getAggregationTypeSqlLabel(
    spec.aggregation?.type ?? MetricsV1AggregationType.AggregationTypeSum,
  );
  const value = spec.measurement?.name || '*';
  const withThreshold = applyThreshold(
    `${aggLabel}(${value})`,
    spec.aggregation?.threshold,
  );
  return applyCap(withThreshold, spec.aggregation?.cap);
};

export const averageSnippet = ({
  entity,
  factTable,
  measurement,
}: AverageSnippetArgs): string => {
  const entityCol = quoteIdentifier(entity || 'entity');
  const factTableName = quoteIdentifier(factTable || 'fact_table');
  const replaceMissingWithZero =
    measurement.nullHandling?.replaceEntityNullWithZero ?? false;
  const aggregation = buildAverageAggregation(
    measurement.typeSpec.averageMetricSpec,
  );

  return `WITH measurements AS (
  SELECT
    ${entityCol},
    ${aggregation} as measure
  FROM ${factTableName}${filterToWhereClause(measurement.filter)}
  GROUP BY ${entityCol}
)

SELECT
  AVG(${coalesceToZeroIf('measure', replaceMissingWithZero)}) as metric
FROM measurements`;
};
